import ApplicationTitle from './ApplicationTitle';
export { ApplicationTitle };
export default ApplicationTitle;
